import Flex from "@/shared/components/common/Flex";
import PhosphorIcon from "@/shared/components/common/PhosphorIcon";
import Typography from "@/shared/components/common/Typography";
import type { MouseEvent } from "react";

interface FlightCardToggleProps {
  handleToggle: (panel: string) => (e: MouseEvent) => void;
  isOpen: boolean;
  panel: string;
  label: string;
  icon?: string;
}

export default function FlightCardToggle({
  handleToggle,
  isOpen,
  panel,
  label,
  icon,
}: FlightCardToggleProps) {
  return (
    <Flex
      onClick={handleToggle(panel)}
      gap={"2"}
      alignItems={"center"}
      className="rounded-full p-1 px-2 cursor-pointer group"
    >
      {icon && (
        <PhosphorIcon
          name={icon as keyof typeof PhosphorIcon}
          size={20}
          weight={isOpen ? "fill" : "regular"}
          className="cursor-pointer text-primary group-hover:text-primary-80 transition duration-75 ease-in-out"
        />
      )}
      <Typography
        variant="caption"
        fontWeight="normal"
        className="text-foreground md:text-sm group-hover:text-primary transition duration-75 ease-in-out"
      >
        {label}
      </Typography>
    </Flex>
  );
}
